export interface ImageDimensions {
  width: number;
  height: number;
}

export async function getImageDimensions(
  file: File
): Promise<ImageDimensions | undefined> {
  if (!file.type.startsWith('image/')) return;

  try {
    const bitmap = await createImageBitmap(file);
    const { width, height } = bitmap;
    bitmap.close();
    return { width, height };
  } catch {
    return;
  }
}

function isHeicFile(file: File): boolean {
  const ext = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();

  return ext.endsWith('.heic') || mimeType === 'image/heic';
}

export async function normalizeImageFormat(file: File): Promise<File> {
  if (!isHeicFile(file)) {
    return file;
  }

  const { heicTo } = await import('heic-to');

  const jpegBlob = await heicTo({
    blob: file,
    type: 'image/jpeg',
    quality: 1,
  });

  const newFilename = file.name.replace(/\.heic$/i, '.jpg');

  return new File([jpegBlob], newFilename, { type: 'image/jpeg' });
}
